import { useSyncExternalStore } from 'react';

import { getPendingRequestsCount, subscribeToPendingRequests } from '../utils/PendingRequests';

export function usePendingRequestsCount() {
    return useSyncExternalStore(subscribeToPendingRequests, getPendingRequestsCount);
}
